import { config } from '@/Pejer'
import HomeView from '@/views/HomeView.vue'
import LoginViewVue from '@/views/LoginView.vue'
import PejerBase from 'pejer/src'
import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/login',
      meta: {
        hideNavbar: true,
        unauthenticatedAccess: true,
      },
      children: [
        {
          path: '',
          name: 'login',
          component: LoginViewVue,
        },
        {
          path: 'otp',
          children: [
            {
              path: '',
              name: 'one-time-password',
              component: () =>
                import('pejer/src/views/Login/OneTimePassword/OneTimePasswordInputView.vue'),
            },
            {
              path: 'setup',
              name: 'one-time-password-setup',
              component: () =>
                import('pejer/src/views/Login/OneTimePassword/OneTimePasswordSetupView.vue'),
            },
          ],
        },
      ],
    },
    {
      path: '/payments',
      children: [
        {
          path: '',

          name: 'payments',
          component: () => import('../views/Payments/PaymentsView.vue'),
        },

        {
          path: ':id',
          name: 'payment',
          component: () => import('../views/Payments/PaymentView/PaymentView.vue'),
        },
      ],
    },
    {
      path: '/kidTransactions',
      children: [
        {
          path: '',
          name: 'kidTransactions',
          component: () => import('../views/KidNorwayTransactions/KidNorwayTransactionsView.vue'),
        },

        // {
        //   path: ':id',
        //   name: 'payment',
        //   component: () => import('../views/Payments/PaymentView/PaymentView.vue'),
        // },
      ],
    },
    {
      path: '/refunds',
      children: [
        {
          path: '',
          name: 'refunds',
          component: () => import('../views/Refunds/RefundsView.vue'),
        },
      ],
    },
    {
      path: '/businesses',
      children: [
        {
          path: '',
          name: 'businesses',
          component: () => import('../views/Business/BusinessesView.vue'),
        },
        {
          path: ':countryCode/:organizationId',
          name: 'business',
          component: () => import('../views/Business/BusinessView/BusinessView.vue'),
        },
      ],
    },
    {
      path: '/customers',
      children: [
        {
          path: '',
          name: 'customers',
          component: () => import('../views/Customers/CustomersView.vue'),
        },
        {
          path: ':id',
          name: 'customer',
          component: () => import('../views/Customers/CustomerView.vue'),
        },
      ],
    },
    {
      path: '/payouts',
      children: [
        {
          path: '',
          name: 'payouts',
          component: () => import('../views/Payouts/PayoutsView.vue'),
        },
        {
          path: ':id',
          name: 'payout',
          component: () => import('../views/Payouts/PayoutView.vue'),
        },
        {
          path: ':id/payment-voucher',
          name: 'payouts-payment-voucher',
          component: () => import('pejer/src/views/Payouts/PaymentVoucher/PaymentVoucherView.vue'),
          meta: {
            unauthenticatedAccess: true,
            hideNavbar: true,
            fillScreen: true,
            title: 'Utbetalingsbilag',
          },
        },
      ],
    },
    {
      path: '/accounts',
      children: [
        {
          path: '',
          name: 'accounts',
          component: () => import('../views/Accounts/AccountsView.vue'),
        },

        {
          path: ':id',
          name: 'account',
          component: () => import('../views/Accounts/AccountView/AccountView.vue'),
        },
        {
          path: ':id/edit',
          name: 'editAccount',
          meta: {
            // hideNavbar: true,
            fillScreen: true,
          },
          component: () => import('../views/Accounts/AccountView/EditView.vue'),
        },
        {
          path: 'onBoarding/:connectedAccountID',
          name: 'viewAccountOnBoarding',
          meta: {
            hideNavbar: true,
            fillScreen: true,
            unauthenticatedAccess: true,
          },
          component: () => import('../views/Accounts/AccountView/Onboarding/OverviewView.vue'),
        },
        {
          path: 'onBoarding/:linkID/edit',
          name: 'editAccountOnBoarding',
          meta: {
            hideNavbar: true,
            fillScreen: true,
            unauthenticatedAccess: true,
          },
          component: () => import('../views/Accounts/AccountView/Onboarding/EditView.vue'),
        },
        {
          path: 'onBoarding/sign',
          children: [
            {
              path: ':linkID',
              name: 'signAccountOnBoarding',
              meta: {
                hideNavbar: true,
                fillScreen: true,
                unauthenticatedAccess: true,
              },
              component: () => import('../views/Accounts/AccountView/Onboarding/SigningView.vue'),
            },
            {
              path: 'not-found',
              name: 'signLinkNotFoundAccountOnBoarding',
              meta: {
                hideNavbar: true,
                fillScreen: true,
                unauthenticatedAccess: true,
              },
              component: () =>
                import('../views/Accounts/AccountView/Onboarding/SignLinkNotFound.vue'),
            },
          ],
        },
        {
          path: 'onBoarding/bankID',
          children: [
            {
              path: 'abort',
              name: 'onBoardingBankIDAbort',
              meta: {
                hideNavbar: true,
                fillScreen: true,
                unauthenticatedAccess: true,
              },
              component: () =>
                import('../views/Accounts/AccountView/Onboarding/BankID/BankIDAbortView.vue'),
            },
            {
              path: 'error',
              name: 'onBoardingBankIDError',
              meta: {
                hideNavbar: true,
                fillScreen: true,
                unauthenticatedAccess: true,
              },
              component: () =>
                import('../views/Accounts/AccountView/Onboarding/BankID/BankIDErrorView.vue'),
            },
          ],
        },
      ],
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('../views/Users/UsersView.vue'),
    },
    {
      path: '/developer',
      name: 'developer',
      component: () => import('../views/Developer/DeveloperView.vue'),
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('../views/Settings/SettingsView.vue'),
    },
    // {
    //   path: '/payment/:paymentReferenceID/invoice',
    //   name: 'payment-invoice',
    //   meta: {
    //     unauthenticatedAccess: true,
    //     hideNavbar: true,
    //     // fillScreen: true,
    //   },
    //   component: InvoiceView,
    // },
  ],
})

router.beforeEach((to, from, next) => {
  // First change the title of the page
  document.title = (to.meta.title as string) ?? 'Bucky Admin Panel'
  if (!PejerBase.hasCookie(config.cookieNames.platformToken) && !to.meta.unauthenticatedAccess) {
    next({ name: 'login', query: { errorCode: '401' } })
  } else next()
})

export default router
